// extracted by mini-css-extract-plugin
export default {"info":"style_info__vCIPX","currentTariffInfo":"style_currentTariffInfo__CEpAv","title":"style_title__avnmu","storageLeftovers":"style_storageLeftovers__EHder"};